import { PlayIcon } from '@anm/components/PreviewInContext/Wrapper';
import ThumbnailEmbed from '@anm/components/ThumbnailEmbed';
import { THUMB_MIN_WIDHT } from '@anm/constants/embed';
import { VideoSizes } from '@anm/hosting-player';
import isEqual from 'lodash/fp/isEqual';
import { memo, FC } from 'react';

import { EmbedItemProps } from '..';
import vtConfig from '../../../../../../config';
import { CommonPreviewWrapper, ThumbnailPreviewWrapper } from '../Wrapper';

type ThumbnailEmbedPreviewProps = EmbedItemProps & {
  videoName: string;
  isNoVideo: boolean;
};

const getPreviewSizes = (sizes: VideoSizes): VideoSizes => {
  const ratio = sizes.width / sizes.height;
  const thumbHeight = Math.round(THUMB_MIN_WIDHT / ratio);

  return {
    width: THUMB_MIN_WIDHT,
    height: thumbHeight
  };
};

const ThumbnailEmbedPreview: FC<ThumbnailEmbedPreviewProps> = ({ hostId, isNoVideo, embedData, videoName }) => {
  const sizes = getPreviewSizes(embedData.sizes);

  return (
    <CommonPreviewWrapper sizeType={embedData.sizeType}>
      <ThumbnailEmbed {...{ sizes, hostId, videoName }} button={embedData.popover.button} isProd={vtConfig().isProd}>
        {isNoVideo && (
          <ThumbnailPreviewWrapper height={sizes.height}>
            <PlayIcon color={embedData.popover.button.color} />
          </ThumbnailPreviewWrapper>
        )}
      </ThumbnailEmbed>
    </CommonPreviewWrapper>
  );
};

const MemoizedThumbnailEmbedPreview = memo(
  ThumbnailEmbedPreview,
  (p, n) => !isEqual(p.embedData.sizes, n.embedData.sizes)
);

export default MemoizedThumbnailEmbedPreview;
